import axios from "axios"
import {notification,message} from "antd";

let baseURL= '';
let usfURL='';
let frankfurtUrl = '';
let lenovoIdURL = '';
let headers='';
let usfHeaders='';
let frankfurtHeaders='';
let tenantId;

if(process.env.REACT_APP_ENV==="development" || process.env.NODE_ENV==="development"){
    // baseURL="/earth-sit/lfsa/"
    // usfURL="/usf-tst/dspf/admin/"
    baseURL="https://zuul-tst.lmp-sy.xpaas.lenovo.com/lfsa/"
    usfURL="https://zuul-tst.lmp-sy.xpaas.lenovo.com/dspf/admin/"
    frankfurtUrl = 'https://zuul-tst.lmp-sy.xpaas.lenovo.com/lfsa/dispute/'
    lenovoIdURL = "https://cn-test.lenovomm.cn/"
    headers = {
        'SERVICE-AUTHENTICATION': 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjI5NTMiLCJmdWxsU2VydmljZU5hbWUiOiJMRlNBLS1zc28iLCJzZXJ2aWNlS2V5IjoiMmVjNmUyNzFlODAwNDQzZTgzYmVlZmJmNmNjNjk1ZDAiLCJzZXJ2aWNlVHlwZSI6IjEiLCJzZXJ2aWNlQXBwIjoiNDQzIiwic2VydmljZUNsdXN0ZXIiOiIzIiwianRpIjoiN2I0ZDRlZmM2MjAwNDEwYmJhYjkwOTc5OGRmZmVlYzMiLCJpYXQiOjE2MTg4MjY4Njl9.mxLcikzl0jswp7eYSY3OFrcp-L__vRsghkYaq2uF3IQ',
    }
    frankfurtHeaders = {
        'SERVICE-AUTHENTICATION': 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjM0MjAiLCJmdWxsU2VydmljZU5hbWUiOiJMRlNBLS1kaXNwdXRlIiwic2VydmljZUtleSI6ImIxYjEyNDU0NzAyMjQ1YWY4ZGMwOGMxZWUzYWE0ZmFkIiwic2VydmljZVR5cGUiOiIxIiwic2VydmljZUFwcCI6IjQ0MyIsInNlcnZpY2VDbHVzdGVyIjoiMyIsImp0aSI6ImMxYjdhOGYxMjVlZjRiMDU4NTlkN2QzNzU3MTgxNWZiIiwiaWF0IjoxNjMxNjczMDA5fQ.BQFujCb7jnE9vNi6wHDB9Gjypo7ueVzX1Xl2U3c0Cdc',
    }
    usfHeaders = {
        'SERVICE-AUTHENTICATION': 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjIzMiIsInNlcnZpY2VLZXkiOiJhODhhODlmMGZjNmQ0MjRiYjI4NTFjYTljNWViZDdjMiIsInNlcnZpY2VUeXBlIjoiMSIsInNlcnZpY2VBcHAiOiIxMDMiLCJzZXJ2aWNlQ2x1c3RlciI6IjMiLCJqdGkiOiJlNzBmMmEwZTdlNWI0M2NkYjk3YTFkZWFjOTQ2NTM0NyIsImlhdCI6MTU1MTg0NDk5M30.dJJCGXkR1-xEKPg8-PZa6gaRy6PKxfPwO2Jve5gRHjQ',
    }
    tenantId = 116;
}else {
    baseURL="/earth-prod/lfsa/"
    usfURL="/usf-prod/dspf/admin/"
    frankfurtUrl = "/earth-frankfurt-prod/"
    lenovoIdURL = "https://sdcsso.lenovo.com/"
    headers = {
        'SERVICE-AUTHENTICATION': 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjMzMTciLCJmdWxsU2VydmljZU5hbWUiOiJMRlNBLS1kaXNwdXRlLXdlYiIsInNlcnZpY2VLZXkiOiIxOGQzMmVjYjhlY2M0OTg5YTlkMTE0MTViMzc2OTdhMCIsInNlcnZpY2VUeXBlIjoiMiIsInNlcnZpY2VBcHAiOiI0NDMiLCJzZXJ2aWNlQ2x1c3RlciI6IjEwIiwianRpIjoiMTQyYWY2YTJhZTNiNGM4MTk5NDgwNWUwOGQ2MTMwMWYiLCJpYXQiOjE2NDI1ODM2OTF9.Skz460cWRJDPTcIBm0MdMOuqzGaxj38PCNYWozAiG-E',
    }
    usfHeaders = {
        'SERVICE-AUTHENTICATION': 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjIzMiIsInNlcnZpY2VLZXkiOiIyNzY0ZWQ0YjlkMWM0ZThlYjhhYzU4ZTIyZmEzMjM5YyIsInNlcnZpY2VUeXBlIjoiMSIsInNlcnZpY2VBcHAiOiIxMDMiLCJzZXJ2aWNlQ2x1c3RlciI6IjUiLCJqdGkiOiI4NGEzODcxOTJjZGM0MGFlYTVlNzFiZDVhODgyNTVlMiIsImlhdCI6MTU1MzY2OTIwMn0.ZBBI_8Icd_sVCGV3WpfSYruAWUwvvwKq9hw1OU4NJUM',
    }
    frankfurtHeaders = {
        'SERVICE-AUTHENTICATION': 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjUxNzMiLCJmdWxsU2VydmljZU5hbWUiOiJkaXNwdXRlLWZyYW5rZnVydC0tRGlzcHV0ZVBvcnRhbCIsInNlcnZpY2VLZXkiOiIyZTY1ZWQ4OGYyODc0NjBkYjNjN2M0ODQ0N2E3N2E4MCIsInNlcnZpY2VUeXBlIjoiMSIsInNlcnZpY2VBcHAiOiIxNjc0Iiwic2VydmljZUNsdXN0ZXIiOiIyMCIsImp0aSI6IjM0MjhkMTU5NjQ3MjRlZDRiZjkzZmYxMzg3MjcyNWVjIiwiaWF0IjoxNjc3NDk0MTY0fQ.c8XutcPaHodv3Y3kTteshylwO9KEEO4SCxuuR_hnNRw',
    }
    tenantId = 38;
}
// 响应拦截处理
axios.interceptors.response.use(
    response => {
        // console.log('response')
        if(response.data?.retCode==='401'){
            window.localStorage.removeItem('userId');
            window.localStorage.removeItem('pcsBpId');
            window.localStorage.removeItem('dcgBpId');
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('userToken');
            window.localStorage.removeItem('lenovoid');
            window.localStorage.removeItem('sst');
            window.localStorage.removeItem('menuList');
            message.warn('Auth failed, please relogin', 1.5)
                .then(()=>{
                    if(window.location.pathname==="/disputeHome"){
                        window.location.reload()
                    }else {
                        window.self.location.href='/disputeHome'
                    }
                })
        }
        return Promise.resolve(response.data)
    },
    error => {
        notification['error']({
            message: 'error',
            description: error.toString(),
        });
        const errorCode = error.toString().substr(-3, 3)
        if(errorCode==='401'){
            window.localStorage.removeItem('userId');
            window.localStorage.removeItem('pcsBpId');
            window.localStorage.removeItem('dcgBpId');
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('lenovoid');
            window.localStorage.removeItem('sst');
            window.localStorage.removeItem('userToken');
            window.localStorage.removeItem('menuList');
            message.warn('Auth failed, please relogin', 1.5)
                .then(()=>{
                    if(window.location.pathname==="/disputeHome"){
                        window.location.reload()
                    }else {
                        window.self.location.href='/disputeHome'
                    }
                })
        }
        return Promise.reject(error)
    }
)
axios.defaults.timeout=200000;

export function Login(params){
    let {userid,pwd} = params
    return axios.post(baseURL+'sso/loginCheckLI?userid='+userid+'&pwd='+pwd+'', {},{
        headers
    })
}

//调用sso接口 获取LenovoID的信息，获取userToken
//{
// "retCode": "200",
// "retMsg": "Successful",
// "data": {
//     "userToken": "external",
//     "lenovoid": "1300001462822",
//     "userType": "external",
//     "userName": "t1d_admin_dk_authorized@dummy.com"
// }
// }
export function getLenovoIdInfo(webauthn_st,webauthn_realm) {
    return axios.get( frankfurtUrl + 'v1.0/dispute/getLenovoID?webauthn_st='+ webauthn_st + '&webauthn_realm='+webauthn_realm,{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            ...frankfurtHeaders
        }
    })
}

export function sapLogout() {
    let userToken = window.localStorage.getItem('userToken')
    return axios.get( baseURL + 'sso/logoutLI',{
        headers:{
            userToken:userToken,
            ...headers
        }
    })
}

//lenovoID退出
export function lenovoIDLogout() {
    let url = window.location.origin
    let lenovoIdLoginUrl = lenovoIdURL+"webauthn/gateway?webauthn_action=uilogout&webauthn_lang=en_US&webauthn_realm=lfsa-dispute-web&webauthn_callback="+url+"/disputeHome"
    window.location.href = lenovoIdLoginUrl;
}

//跳转到lenovoID登录页面
export function lenovoIDLogin() {
    let url = window.location.origin
    let lenovoIdLoginUrl = lenovoIdURL+"webauthn/gateway?webauthn_action=uilogin&webauthn_lang=en_US&webauthn_realm=lfsa-dispute-web&webauthn_callback="+url+"/callback"
    window.location.href = lenovoIdLoginUrl;
}

//通过UCA登录
export function usfLogin() {
    let url = window.location.origin
    let authUrl = 'user/adfsindex';
    window.localStorage.setItem('userType','internal');
    return axios.get( usfURL + authUrl + '?returnTo='+url+'/usfLogin',{
        headers:{
            ...usfHeaders
        }
    }).then(response =>{
        return response.replace('zh_CN','en_US')
    })
}

export function toggleTenant() {
    let userToken = window.localStorage.getItem('userToken')
    return axios.put( usfURL + 'sys/user/tenant',{
        tenantId: tenantId
    },{
        headers:{
            token:userToken,
            ...usfHeaders
        }
    })
}

export function getMenuTree() {
    let userToken = window.localStorage.getItem('userToken')
    return axios.post( usfURL + 'sys/menu/tree',{},{
        headers:{
            token:userToken,
            ...usfHeaders
        }
    })
}

//UCA退出
export function usfLogout(){
    let url = window.location.origin
    let userToken = window.localStorage.getItem('userToken')
    if(userToken){
        // let url = 'https://lfsa-dispute-web-sit.appz1p-syex.earth.xcloud.lenovo.com'
        return axios.post( usfURL + 'user/usflogout?returnTo='+url+'/disputeHome',{},{
            headers:{
                token:userToken,
                ...usfHeaders
            }
        }).then(response =>{
            return response
        })
    }else{
        window.location.href='/disputeHome'
    }

}
// ADFS退出
export function internalLogout() {
    let url = window.location.origin
    // let url = 'https://lfsa-dispute-web-sit.appz1p-syex.earth.xcloud.lenovo.com'
    return axios.post( usfURL + 'user/adfs/sls?returnTo='+url+'/disputeHome',{},{
        headers:{
            ...usfHeaders
        }
    }).then(response =>{
        return response
    })
}
//lenovoID退出
export function externalLogout() {
    let url = window.location.origin
    // let url = 'https://lfsa-dispute-web-sit.appz1p-syex.earth.xcloud.lenovo.com'
    return axios.post( usfURL + 'lenovoid/uilogout?returnTo='+url+'/disputeHome',{},{
        headers:{
            ...usfHeaders
        }
    }).then(response =>{
        return response
    })
}



export function checkToken(token) {
    let key = Math.random()
    return axios.get( usfURL + 'sys/user/token?key='+key,{
        headers:{
            token:token,
            ...usfHeaders
        }
    })
}

export function getTokenByUser(userId) {
    return axios.get( baseURL + 'sso/getTokenByUser?userId='+userId,{
        headers
    })
}

export function getIdByticketLI(ticket) {
    window.localStorage.setItem('userType','sap');
    return axios.post( baseURL + 'sso/getIdByticketLI?ticket='+ ticket,{},{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            ...headers
        }
    })
}

export  function dispute_types(){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.get(frankfurtUrl+'v1.0/dispute/dispute_types',{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function getUserType(){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    let lenovoid  = window.localStorage.getItem('lenovoid')
    let sst= window.localStorage.getItem('sst')
    return axios.get(frankfurtUrl+'v1.0/channel_partner_auth',{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            'lenovoid':lenovoid,
            'sst':sst,
            ...frankfurtHeaders
        }
    })
}

export function invoice_table_data(invoice_number,serial_number,region,businessUnit,isPartnerHubUser){
    // let userId = window.localStorage.getItem('userId')
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/dispute/invoice_validation',{
        businessUnit:businessUnit,
        invoice:invoice_number,
        region:region,
        serialNumber:serial_number,
        // userId:userId,
        isPartnerHubUser:isPartnerHubUser?true:false
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function country_select_list(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.get(frankfurtUrl+'v1.0/dispute/countries_by_regions?regions='+params+'&needCountryText=true',{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function dispute_approval_search(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/dispute_search',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function financial_claim_search(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/report_query',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function cbso_claim_search(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/cbso/report_query',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function financial_download_report(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/download_report',{
        ...params
    },{
        responseType: 'blob',
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function cbso_download_report(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/cbso/download_report',{
        ...params
    },{
        responseType: 'blob',
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function financial_claim_detail(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/detail_query?claimId='+params.claimId+'&claimReqNo='+params.claimReqNo+'',{},{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function cbso_claim_detail(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/cbso/detail_query?claimId='+params.claimId+'&claimReqNo='+params.claimReqNo+'',{},{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function dispute_approval_report(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/dispute_report',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function financial_claim_query(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/approve_query',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function dispute_approval_item(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.get(frankfurtUrl+'v1.0/dispute_detail?disputeNo='+params,{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function dispute_approval(action,params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/disputes',
        params
        ,{
            headers:{
                'username':'licrm',
                'password':'1234Qaz',
                'userToken':userToken,
                'userType':userType,
                ...frankfurtHeaders
            }
        })
}

export function authority(){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.get(frankfurtUrl+'v1.0/dispute/user_auth_info',{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}
export function getAttachment(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.get(frankfurtUrl+'v1.0/dispute/attachment?dispute_id='+params,{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}
export function downloadAttachment(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.get(frankfurtUrl+'v1.0/dispute/downloadAttachment?file_name='+params,{
        responseType: 'blob',
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function uploadAttachment(file){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    let data = new FormData();
    data.append(`attachment`,file)
    return axios.post(frankfurtUrl+'v1.0/dispute/attachment_upload',
        data
        ,{
            headers:{
                'username':'licrm',
                'password':'1234Qaz',
                "Content-Type": "multipart/form-data",
                "type": "formData",
                'userToken':userToken,
                'userType':userType,
                ...frankfurtHeaders
            }
        })
}

export function dispute_submit(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    let data = new FormData();
    for (let key in params){
        if(params[key]){

            if(key==="invoiceInfos"){
                let arr = params[key];
                // 校验提交的sold to是否相同
                let soldToNumber = "";
                if (arr && arr[0]) {
                    soldToNumber = arr[0].soldToNumber;
                }
                for(let i=0;i<arr.length;i++){
                    if (arr[i].soldToNumber !== soldToNumber) {
                        message.warn('Sold to should to be same in one dispute, pls check!');
                        return Promise.reject();
                    }
                    for(let IK in arr[i]){
                        //数组对应的字段为invoiceInfos
                        data.append(`invoiceInfos[${i}].${IK}`,arr[i][IK])
                    }
                }
            }else if(key==="attachments"){
                let arr = params[key];
                for(let i=0;i<arr.length;i++){
                    //数组对应的字段为attachments
                    if(arr[i].typeCode==="COFCF" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'COFCF')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="DFDSP" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'DFDSP')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="LFAOE" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'LFAOE')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="TEMFO" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'TEMFO')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="SNODB" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'SNODB')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="DAMIM" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'DAMIM')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="SERPR" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'SERPR')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }else if(arr[i].typeCode==="DOAPR" && arr[i].attachments.length){
                        data.append(`attachments[${i}].type`,'DOAPR')
                        arr[i].attachments.forEach((item,index)=>{
                            if (item.fileList[0]) {
                                data.append(`attachments[${i}].fileList[${index}]`,item.fileList[0].data.s3FileName);
                            }
                        })
                    }
                }
            }else if(key==="ccEmailAddress"){
                let arr = params[key];
                for(let i=0;i<arr.length;i++){
                    if(arr[i]){
                        data.append(`ccEmailAddress[${i}]`,arr[i])
                    }
                }
            }else{
                data.append(key,params[key]);
            }
        }
    }
    return axios.post(frankfurtUrl+'v1.0/dispute',
        data
        ,{
            headers:{
                'username':'licrm',
                'password':'1234Qaz',
                "Content-Type": "multipart/form-data",
                "type": "formData",
                'userToken':userToken,
                'userType':userType,
                ...frankfurtHeaders
            }
        })
}

export function contact_person_select(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    const {partnerId,relationType} = params
    return axios.get(baseURL+'partners/relationships?partnerIds='+partnerId+'&relationType='+relationType+'',{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...headers
        }
    })
}

export function basic_info(params){
    // let userId = window.localStorage.getItem('userId')
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    let cbso;
    if(params){
        cbso=true
    }else{
        cbso=false
    }
    return axios.get(frankfurtUrl+'v1.0/financial_claim/basic_info?region=WE&cbso='+cbso,{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function claims_search(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/claims',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function mass_upload(file,params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    // let userId = window.localStorage.getItem('userId')
    const {disputeType,region,businessUnit,isPartnerHubUser,templateFlag} = params
    return axios.post(frankfurtUrl+'v1.0/dispute/mass_upload_check?disputeType='+disputeType+'&region='+region+'&businessUnit='+businessUnit+'&isPartnerHubUser='+isPartnerHubUser+'&templateFlag='+templateFlag+'',
        file
        ,{
            headers:{
                'username':'licrm',
                'password':'1234Qaz',
                'userToken':userToken,
                'userType':userType,
                ...frankfurtHeaders
            }
        })
}

export function financial_mass_upload(file,cbso){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    // let userId = window.localStorage.getItem('userId')
    return axios.post(frankfurtUrl+'v1.0/financial_claim/mass_upload?cbso='+cbso+'',
        file
        ,{
            headers:{
                'username':'licrm',
                'password':'1234Qaz',
                'userToken':userToken,
                'userType':userType,
                ...frankfurtHeaders
            }
        })
}

export function claims_save_ecc(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.put(frankfurtUrl+'v1.0/financial_claim/claims',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}
export function claims_create(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.post(frankfurtUrl+'v1.0/financial_claim',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}
export function claims_save_local(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.put(frankfurtUrl+'v1.0/financial_claim/local_claims',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}


export function financial_claim_approval(params){
    let userToken = window.localStorage.getItem('userToken')
    let userType  = window.localStorage.getItem('userType')
    return axios.put(frankfurtUrl+'v1.0/financial_claim/claims',{
        ...params
    },{
        headers:{
            'username':'licrm',
            'password':'1234Qaz',
            'userToken':userToken,
            'userType':userType,
            ...frankfurtHeaders
        }
    })
}

export function getQueryVariable(variable){
    let reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}


